const stats = [
  { value: '500+', label: 'Happy Clients' },
  { value: '20+', label: 'Years in Business' },
  { value: '99%', label: 'Client Retention' },
  { value: '50+', label: 'Certified Staff' },
];

const values = [
  {
    icon: 'ri-shield-check-line',
    title: 'Reliability',
    desc: 'We show up on time, every time. Our clients count on us and we never let them down.',
  },
  {
    icon: 'ri-leaf-line',
    title: 'Sustainability',
    desc: 'Eco-certified products and green practices that protect your team and the planet.',
  },
  {
    icon: 'ri-award-line',
    title: 'Excellence',
    desc: 'ISO-certified processes and rigorous quality audits ensure consistently superior results.',
  },
  {
    icon: 'ri-team-line',
    title: 'People First',
    desc: 'Background-checked, trained, and fairly compensated staff who take pride in their work.',
  },
];

export default function About() {
  return (
    <section id="about" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
          {/* Left: Images */}
          <div className="relative">
            <div className="grid grid-cols-2 gap-4">
              <div className="w-full h-64 rounded-2xl overflow-hidden">
                <img
                  src="https://public.readdy.ai/ai/img_res/26152d60c23cc968304ae4a0708b63cc.jpg"
                  alt="Our cleaning team"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="w-full h-64 rounded-2xl overflow-hidden mt-8">
                <img
                  src="https://readdy.ai/api/search-image?query=eco-friendly%20cleaning%20products%20and%20equipment%20arranged%20neatly%2C%20green%20sustainable%20cleaning%20supplies%2C%20professional%20commercial%20cleaning%20tools%2C%20white%20background%2C%20clean%20and%20organized%2C%20natural%20tones&width=400&height=300&seq=about002&orientation=portrait"
                  alt="Eco-friendly products"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="col-span-2 w-full h-48 rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=clean%20modern%20corporate%20office%20lobby%20reception%20area%2C%20polished%20marble%20floors%2C%20bright%20natural%20lighting%2C%20minimalist%20interior%20design%2C%20spotless%20surfaces%2C%20professional%20business%20environment%2C%20neutral%20tones%2C%20elegant%20and%20pristine&width=800&height=250&seq=about003&orientation=landscape"
                  alt="Clean corporate lobby"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>

            {/* Floating badge */}
            <div className="absolute top-4 -right-4 bg-[#1a3a2a] text-white rounded-xl px-4 py-3 hidden lg:block">
              <div className="text-2xl font-bold" style={{ fontFamily: "'Syne', sans-serif" }}>20+</div>
              <div className="text-xs text-white/60">Years of Trust</div>
            </div>
          </div>

          {/* Right: Content */}
          <div>
            <span
              className="text-[#4caf7d] text-xs font-semibold tracking-widest uppercase"
              style={{ fontFamily: "'Syne', sans-serif" }}
            >
              Our Story
            </span>
            <h2
              className="text-3xl md:text-5xl font-bold text-[#1a3a2a] mt-2 mb-6 leading-tight"
              style={{ fontFamily: "'Syne', sans-serif" }}
            >
              Built on Trust,<br />Driven by<br />
              <span className="text-[#4caf7d]">Excellence</span>
            </h2>
            <p className="text-gray-500 text-sm leading-relaxed mb-4">
              Founded in 2004, DAS Cleaning started with a simple mission: deliver commercial cleaning services that clients can truly rely on. We grew from a 5-person team serving local offices to a 50+ strong workforce trusted by some of the region&apos;s most demanding organizations.
            </p>
            <p className="text-gray-500 text-sm leading-relaxed mb-8">
              Every member of our team is background-checked, professionally trained, and equipped with the latest eco-certified cleaning technology. We don&apos;t just clean — we create environments where people thrive.
            </p>

            {/* Stats */}
            <div className="grid grid-cols-2 gap-4 mb-10">
              {stats.map((stat) => (
                <div key={stat.label} className="bg-[#f8f9f7] rounded-xl p-4">
                  <div
                    className="text-2xl font-bold text-[#1a3a2a]"
                    style={{ fontFamily: "'Syne', sans-serif" }}
                  >
                    {stat.value}
                  </div>
                  <div className="text-gray-400 text-xs mt-0.5">{stat.label}</div>
                </div>
              ))}
            </div>

            {/* Values */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {values.map((v) => (
                <div key={v.title} className="flex gap-3">
                  <div className="w-9 h-9 flex items-center justify-center bg-[#e8f5ee] rounded-lg flex-shrink-0 mt-0.5">
                    <i className={`${v.icon} text-[#4caf7d] text-base`}></i>
                  </div>
                  <div>
                    <div className="text-sm font-bold text-[#1a3a2a]" style={{ fontFamily: "'Syne', sans-serif" }}>
                      {v.title}
                    </div>
                    <div className="text-gray-400 text-xs mt-0.5 leading-relaxed">{v.desc}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
